import { Component } from '@angular/core';

@Component({
    selector: 'gl-box',
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
    standalone: false
})
export class BoxComponent {
}
